import { useState } from "react"
import PageLayout from "components/layout/PageLayout"
import { useGetMyWhistlesQuery } from "./api/whistleApiSlice"
import PaginationBar from "components/widget/PaginationBar"
import NewWhistleModal from "./components/NewWhistleModal"
import FetchAnonymousWhistleModal from "./components/FetchAnonymousWhistleModal"
import { useTranslation } from "react-i18next"
import WhistleCard from "./components/WhistleCard"

const MyWhistles = () => {

    const [t] = useTranslation(["global", "whistle"])
    const [requestPage, setRequestPage] = useState(0)

    const {
        data: response,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch
    } = useGetMyWhistlesQuery(requestPage)



    let content

    if (isSuccess) {
        content =
            <div>
                <div className="col mb-2">
                    <NewWhistleModal />  <FetchAnonymousWhistleModal />
                </div>

                <div className={`card bg-black bg-opacity-10 mb-4 mt-4`} id="absence-request">
                    <div className="card-header">
                        <i className="fa-solid fa-circle-exclamation"></i> {t("whistle:menu.warnings")}
                    </div>

                    {
                        response.content.length > 0 ?
                            <div className="card-body text-center p-4">
                                <div className="row text-start text-muted mb-4 px-4 ">
                                    <div className="col-sm-2">
                                        {t("whistle:property.status")}
                                    </div>
                                    <div className="col-sm-1">
                                        {t("whistle:property.priority")}
                                    </div>
                                    <div className="col-sm-7">
                                        {t("whistle:property.object")}
                                    </div>
                                    <div className="col-sm-2">
                                        {t("global:property.submited")}
                                    </div>
                                </div>

                                {response.content.map(whistle => (

                                    <WhistleCard
                                        key={whistle.guid}
                                        whistle={whistle}
                                    />
                                ))}

                                <PaginationBar
                                    currentPage={requestPage + 1}
                                    postsPerPage={response.pageable.pageSize}
                                    totalPosts={response.totalElements}
                                    paginate={(e) => {
                                        console.log(e)
                                        setRequestPage(e - 1)
                                    }}
                                />
                            </div>

                            :
                            <div className="text-center opacity-50 p-4"><h3><i className="fa-regular fa-folder-open fa-beat"></i> {t("whistle:no_data.no_warnings")}</h3></div>

                    }


                </div>
            </div>
    }



    return <PageLayout
        pageTitle={t("whistle:menu.my_warnings")}
        isLoadingContent={isFetching}
        onPageRefresh={refetch}
        bodyContent={content}
    />
}

export default MyWhistles